import { each } from 'lodash';
import { fetch } from '@utils/utils';

const saveDayPlans = ({ addSuccess, addError }) => async (data: any): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/day-plan`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(data)
    });

    const json: any = await response.json();
    addSuccess('Denní plány byly uloženy');
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const editDayPlan = ({ addSuccess, addError }) => async (data: any): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/day-plan/${data.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(data)
    });

    const json: any = await response.json();
    addSuccess('Denní plán byl upraven');

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const getDayPlan = ({ addError }) => async (id: string): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/day-plan/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: any = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const removeDayPlan = ({ addSuccess, addError }) => async (id: string): Promise<any> => {
  try {
    await fetch(`/metropolis/api/hr/workplan/day-plan/${id}`, {
      method: 'DELETE',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    addSuccess('Denní plán byl odstraněn');
    return true;
  } catch (err) {
    addError(addError);
    return false;
  }
};

const getAllDayPlans = async (params?: any): Promise<any> => {
  let filter = '';
  each(params, (param, index) => each(param, (value, key) => (filter += `&filter[${index}].${key}=${value}`)));
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/day-plan?pageSize=9999${filter}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: any = await response.json();

    return json;
  } catch (err) {
    return {};
  }
};

const getDayPlansForCurrentUser = async (from: string, to: string): Promise<any> => {
  try {
    const response: any = await fetch(
      `/metropolis/api/hr/workplan/day-plan/current-employee?dateFrom=${from}&dateTo=${to}`,
      {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' })
      }
    );

    const json: any = await response.json();

    return json;
  } catch (err) {
    return {};
  }
};

const getCurrentEmployee = async (): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/employees/logged`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: any = await response.json();

    return json;
  } catch (err) {
    return {};
  }
};

export {
  saveDayPlans,
  editDayPlan,
  getDayPlan,
  getAllDayPlans,
  removeDayPlan,
  getDayPlansForCurrentUser,
  getCurrentEmployee
};



// WEBPACK FOOTER //
// ./src/modules/hr-dayplans/_dayplansActions.ts